import styled from 'styled-components'
import { Box } from 'ui'

const PAGE_SIZE = '1440px'

// web-ui's `sm`, where the AppShell leaves its phone layout. In px because
// legacyUiStylisPlugin rescales rems
export const SHELL_SM_BREAKPOINT = '768px'

const PAGE_BORDER_WIDTH = 'var(--ww-border-width-hairline, 1px)'

/**
 * Sets `--page-full-height` (the height under the shell's chrome) and
 * `--page-sticky-top` (below the phone top bar). `isolation` keeps page
 * z-indexes under the shell's navbar and top bar. With `$scrollsInPanel` it
 * fills the panel and scrolls across its full width, like `ModalPagePanel`
 */
export const PageContainer = styled(Box).attrs({
  className: 'page-container',
})<{ $bannerHeight?: number; $inModal?: boolean; $scrollsInPanel?: boolean }>`
  ${({ $bannerHeight = 0, $inModal, $scrollsInPanel }) => `
    isolation: isolate;
    max-width: ${PAGE_SIZE};
    margin-left: auto;
    margin-right: auto;
    --page-full-height: calc(
      100dvh - var(--app-shell-header-offset, 0px) -
        2 * var(--app-shell-padding, 0px)
    );
    --page-sticky-top: ${
      $inModal || $scrollsInPanel
        ? '0px'
        : 'var(--app-shell-header-offset, 0px)'
    };

    ${
      $scrollsInPanel
        ? `
      max-width: none;
      padding-left: max(0px, calc((100% - ${PAGE_SIZE}) / 2));
      padding-right: max(0px, calc((100% - ${PAGE_SIZE}) / 2));
      height: var(--page-full-height);
      overflow-y: auto;
    `
        : ''
    }

    @media (min-width: ${SHELL_SM_BREAKPOINT}) {
      --page-full-height: calc(
        100dvh - 2 * var(--app-shell-padding, 0px) - 2 * ${PAGE_BORDER_WIDTH} -
          ${$bannerHeight}px
      );
    }

    .page-content {
      --padding: calc((100% - ${PAGE_SIZE}) / 2);
      padding-left: var(--padding);
      padding-right: var(--padding);
    }
  `}
`

/** Covers the page panel, leaving the navbar and phone top bar visible */
export const ModalPagePanel = styled(Box)`
  position: fixed;
  top: calc(
    var(--app-shell-header-offset, 0px) + var(--app-shell-padding, 0px)
  );
  left: calc(
    var(--app-shell-navbar-offset, 0px) + var(--app-shell-padding, 0px)
  );
  right: var(--app-shell-padding, 0px);
  bottom: var(--app-shell-padding, 0px);
  overflow: auto;
  background-color: white;

  @media (min-width: ${SHELL_SM_BREAKPOINT}) {
    border: ${PAGE_BORDER_WIDTH} solid var(--ww-color-border-default);
    border-radius: var(--mantine-radius-lg);
  }
`
